import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import ProposalPresentation from './pages/ProposalPresentation';
import RoadmapPresentation from './pages/RoadmapPresentation';
import GrantDiscovery from './pages/GrantDiscovery';
import { PROVIDER_BRAND } from './data/provider-brand';

function App() {
  return (
    <Routes>
      <Route path="/" element={<RoadmapHome />} />
      <Route path="/:companyId/proposal" element={<ProposalPresentation />} />
      <Route path="/:companyId/roadmap" element={<RoadmapPresentation />} />
      <Route path="/:companyId/discover" element={<GrantDiscovery />} />
      <Route path="/:companyId" element={<CompanyRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function CompanyRedirect() {
  return <Navigate to="proposal" replace />;
}

function RoadmapHome() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  if (id) {
    return <Navigate to={`/${id}/proposal`} replace />;
  }

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gradient-to-br from-white via-secondary/15 to-primary/15">
      <div className="text-center max-w-2xl px-6">
        <div className="mb-8">
          <img
            src={PROVIDER_BRAND.logo}
            alt={PROVIDER_BRAND.companyName}
            className="h-16 mx-auto mb-6"
          />
        </div>
        <h1 className="text-4xl font-extrabold mb-4 text-foreground">
          Grant Roadmaps
        </h1>
        <p className="text-xl text-muted-foreground mb-8">
          Please use the specific roadmap link provided to you.
        </p>
        <div className="bg-white/60 backdrop-blur-sm border border-primary/20 rounded-2xl p-6 text-left space-y-3">
          <p className="text-sm text-muted-foreground mb-2">URL format:</p>
          <code className="text-primary font-mono text-sm block">
            roadmap.allegory.world/[company]/proposal
          </code>
          <code className="text-primary font-mono text-sm block">
            roadmap.allegory.world/[company]/roadmap
          </code>
        </div>
      </div>
    </div>
  );
}

export default App;
